export enum FileFormat {
    PDF = 'pdf',
    EXCEL = 'excel',
    WORD = 'docx',
}